import { render, staticRenderFns } from "./VerObjetivo.vue?vue&type=template&id=35d1b677&"
import script from "./VerObjetivo.vue?vue&type=script&lang=js&"
export * from "./VerObjetivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports